/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { SecurityAnswer } from '../models/security-answer';
import { securityAnswersGet } from '../fn/security-answers/security-answers-get';
import { SecurityAnswersGet$Params } from '../fn/security-answers/security-answers-get';
import { securityAnswersPost } from '../fn/security-answers/security-answers-post';
import { SecurityAnswersPost$Params } from '../fn/security-answers/security-answers-post';
import { securityAnswersSetanswerlist } from '../fn/security-answers/security-answers-setanswerlist';
import { SecurityAnswersSetanswerlist$Params } from '../fn/security-answers/security-answers-setanswerlist';

@Injectable({ providedIn: 'root' })
export class SecurityAnswersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `securityAnswersGet()` */
  static readonly SecurityAnswersGetPath = '/api/SecurityAnswers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityAnswersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityAnswersGet$Response(params?: SecurityAnswersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SecurityAnswer>>> {
    return securityAnswersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityAnswersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  securityAnswersGet(params?: SecurityAnswersGet$Params, context?: HttpContext): Observable<Array<SecurityAnswer>> {
    return this.securityAnswersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SecurityAnswer>>): Array<SecurityAnswer> => r.body)
    );
  }

  /** Path part for operation `securityAnswersPost()` */
  static readonly SecurityAnswersPostPath = '/api/SecurityAnswers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityAnswersPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  securityAnswersPost$Response(params: SecurityAnswersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return securityAnswersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityAnswersPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  securityAnswersPost(params: SecurityAnswersPost$Params, context?: HttpContext): Observable<Blob> {
    return this.securityAnswersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `securityAnswersSetanswerlist()` */
  static readonly SecurityAnswersSetanswerlistPath = '/forgot/answerlist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `securityAnswersSetanswerlist()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  securityAnswersSetanswerlist$Response(params: SecurityAnswersSetanswerlist$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return securityAnswersSetanswerlist(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `securityAnswersSetanswerlist$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  securityAnswersSetanswerlist(params: SecurityAnswersSetanswerlist$Params, context?: HttpContext): Observable<string> {
    return this.securityAnswersSetanswerlist$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
